<template lang="html">
  <b-container>
    <b-row>
      <b-col md="6">
        <div v-if="!$store.state.authorized">
          <h1 class="mb-4">Create Account</h1>
          <CreateAccount />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import CreateAccount from "@/components/CreateAccount.vue";

export default {
  name: "PlanTrial",
  components: {
    CreateAccount
  },
  data() {
    return {};
  },
  computed: {
    authorized() {
      return this.$store.state.authorized;
    }
  },
  watch: {
    authorized: {
      handler: function(value) {
        // Redirect if the user already has an account.
        if (value) {
          this.$router.push("account");
        }
      },
      immediate: true
    }
  },
  methods: {}
};
</script>

<style lang="css" scoped>
</style>
